import CmsModel from '@/models/Cms';

const GET_DESTINATION_CITY = 'GET_DESTINATION_CITY';
const GET_DESTINATION_CITY_CHANGE = 'GET_DESTINATION_CITY_CHANGE';

/**
 * 获取目的地城市
 */
async function getDestinationCity(params) {
  const payload = await new CmsModel().getDestinationCity(params);
  return {
    type: GET_DESTINATION_CITY,
    payload
  }
}

async function getDestinationCityChange(params) {
  return {
    type: GET_DESTINATION_CITY_CHANGE,
    payload: params
  }
}

const ACTION_TYPES = {
  GET_DESTINATION_CITY,
  GET_DESTINATION_CITY_CHANGE,
};

const ACTION = {
  getDestinationCity,
  getDestinationCityChange,
};

const DestinationCity = {
  ACTION_TYPES,
  ACTION
}

export default DestinationCity;